import * as types from './types';
import { injectCaliSetsWithCalibrationTimestamp } from '../Components/Accordion/utils';

const initialState = {
    customerPrinters: [],
};

// NOTE: SUBSCRIBE_TO_ADD_PRINTER_SUCCESS and SUBSCRIBE_TO_DELETE_PRINTER_SUCCESS are updated 03/09/2025
// NOTE: ADD_ACTION_PRINTERS_SUCCESS is updated 28/10/2025

export default function printers(state = initialState, payload) {
    switch (payload.type) {
        case types.GET_CUSTOMER_PRINTERS_SUCCESS: {
            return {
                ...state,
                customerPrinters: payload.res.data.listCustomerPrinters.items,
            };
        }

        case types.ADD_ACTION_PRINTERS_SUCCESS: {
            return state;
        }

        case types.SUBSCRIBE_TO_ADD_PRINTER_SUCCESS: {
            // Check if printer already exists to prevent duplicates
            const printerExists = state.customerPrinters.some(
                existingPrinter =>
                    existingPrinter.printerId === payload.newPrinter.printerId &&
                    existingPrinter.cpId === payload.newPrinter.cpId
            );

            if (printerExists) {
                // Printer already exists, don't add duplicate
                return state;
            }

            return {
                ...state,
                customerPrinters: [...state.customerPrinters, payload.newPrinter],
            };
        }

        case types.SUBSCRIBE_TO_DELETE_PRINTER_SUCCESS: {
            const updatedPrinters = state.customerPrinters
                .filter(p => !(p.printerId === payload.deletedPrinter.printerId && p.cpId === payload.deletedPrinter.cpId));
            return {
                ...state,
                customerPrinters: updatedPrinters,
            };
        }

        case types.SUBSCRIBE_TO_UPDATE_PRINTER_SUCCESS:
            return {
                ...state,
                customerPrinters: state.customerPrinters.map((printerInState) => {
                    if (printerInState.printerId === payload.data.printerId &&
                        printerInState.cpId === payload.data.cpId
                    ) {
                        return {
                            ...printerInState,
                            name: payload.data.name,
                            status: payload.data.status,
                            site: payload.data.site,
                            media: payload.data.media,
                            mediaId: payload.data.mediaId,
                            isCalibrated: payload.data.isCalibrated,
                            lastCalibrationDate: payload.data.lastCalibrationDate,
                        };
                    }
                    return printerInState;
                }),
            };

        case types.SUBSCRIBE_TO_PRINTERDETAIL_UPDATE_SUCCESS:
            return {
                ...state,
                customerPrinters: state.customerPrinters.map(printerInState => {
                    if (printerInState.printerId === payload.data.printerId &&
                        printerInState.cpId === payload.data.cpId
                    ) {
                        return {
                            ...printerInState,
                            errorMessage: payload.data.errorMessage,
                            printerType: payload.data.printerType,
                            inks: payload.data.inks,
                            mediaSize: payload.data.mediaSize,
                            mediaSizeId: payload.data.mediaSizeId,
                            inkSet: payload.data.inkSet,
                            medias: payload.data.medias,
                            caliSets: payload.data.caliSets.map(injectCaliSetsWithCalibrationTimestamp),
                        };
                    }
                    return printerInState;
                }),
            };

        default:
            return state;
    }
}
